import { render } from "./RankingTable.vue?vue&type=template&id=34967438"
import script from "./RankingTable.vue?vue&type=script&lang=js"
export * from "./RankingTable.vue?vue&type=script&lang=js"

import "./RankingTable.vue?vue&type=style&index=0&id=34967438&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "34967438"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('34967438', script)) {
    api.reload('34967438', script)
  }
  
  module.hot.accept("./RankingTable.vue?vue&type=template&id=34967438", () => {
    api.rerender('34967438', render)
  })

}

script.__file = "src/components/settings/RankingTable.vue"

export default script